import { Alert, Paper, Stack, Text } from '@mantine/core';
import { AlertCircle } from 'lucide-react';

type TranslationsApiErrorPanelProps = {
  message: string;
};

export function TranslationsApiErrorPanel({
  message,
}: TranslationsApiErrorPanelProps) {
  return (
    <Stack gap='md'>
      <Alert
        icon={<AlertCircle size={16} />}
        title='Endpoint API non disponibile'
        color='red'
        variant='filled'
      >
        <Stack gap='sm'>
          <Text>
            Gli endpoint attesi sono{' '}
            <code>{'POST /services/v1/lang/{id}'}</code> e{' '}
            <code>{'POST /services/v1/lang/{id}/update'}</code> (id app: 1 o 2).
            Body: <code>lang</code> + <code>tags</code> (lettura) o{' '}
            <code>lang</code> + <code>data</code> (scrittura).
          </Text>
          <Text size='sm'>Errore: {message}</Text>
          {/failed to fetch/i.test(message) ? (
            <Text size='sm' mt='xs'>
              &quot;Failed to fetch&quot; di solito indica rete, CORS o URL API
              errato. Il client non invia header personalizzati oltre a{' '}
              <code>X-Localization</code> per evitare blocchi del preflight
              CORS.
            </Text>
          ) : null}
        </Stack>
      </Alert>

      <Paper p='md' withBorder>
        <Stack gap='md'>
          <Text fw={600} size='lg'>
            Contratto backend
          </Text>
          <Text size='sm'>
            L&apos;app è nel path <code>{'{id}'}</code> (1 = Life Experience, 2
            = Life Suite). Le route legacy lifesuite sono deprecate lato server.
          </Text>
        </Stack>
      </Paper>
    </Stack>
  );
}
